module.exports = function(app) {
	app.directive('eprChangeProvider', [function() {
		return {
			restrict: 'A',
			replace: false,
			template: require('directives/assistEmployees/eprChangeProvider.html'),

			scope: {
				participant: '=eprChangeProvider', // in the template we use participant.pcpName  etc
				allParticipants: '=allParticipants',
				reasonCodes: '=reasonCodes',
				employee: '=',
				validationSuffix: '=',
				editMode: '='
			},
			controller: ['$scope', 'navigation', 'sessionData', 'validatePcpFactory', 'employerUtility', '$location', 'services',
				'$window', 'storage', 'modal', 'changePcpSuccess', '$filter',
				function($scope, navigation, sessionData, validatePcpFactory, employerUtility, $location, services,
						 $window, storage, modal, changePcpSuccess, $filter) {

                    var theUbk = sessionData.employerInfo.brandName;
                    $scope.IsIBC = ((theUbk == '6009') || (theUbk == 6008))? true : false;
                    $scope.participant.effectiveDateIB = new Date();
                    $scope.dt1900 = new Date(1900, 1, 1);
                    $scope.dt2500 = new Date(2500, 1, 1);
                    var m = new Date();
                    $scope.getForm = function () {
                        return $scope["Providers_" + $scope.validationSuffix];
                    };
                    $scope.getFormField = function (fieldName) {
                        return $scope.getForm() ? $scope.getForm()[fieldName] : {};
                    };
                    $scope.arrCutOffDates = {
                        'dtEffMin': $scope.dt1900,
                        'dtEffMax': $scope.dt2500,

                    };
					$scope.feedback = {};
                    function truncateToDay(date) {
                        date.setHours(0);
                        date.setMinutes(0);
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        return date;
                    }
                    function isLeap(y)
                    {
                        if (y%100 != 0 && y%4 == 0 || y %400 == 0) {
                            return true;
                        }
                        else {
                            return false;
                        }


                    }

// Given a date, returns number of days elapsed
// from the  beginning of the current year (1st
// jan).
                    function  offsetDays( d,  m,  y)
                    {
                        var offset = d;
                        switch (m)
                        {
                            case 11:
                                offset += 30;
                            case 10:
                                offset += 31;
                            case 9:
                                offset += 30;
                            case 8:
                                offset += 31;
                            case 7:
                                offset += 31;
                            case 6:
                                offset += 30;
                            case 5:
                                offset += 31;
                            case 4:
                                offset += 30;
                            case 3:
                                offset += 31;
                            case 2:
                                offset += 28;
                            case 1:
                                offset += 31;
                        }

                        if (isLeap(y) && m > 2)
                            offset += 1;

                        return offset;
                    }
					$scope.participant.contractCovEffDteForDisplay = '';
					$scope.reasonCodeChanged = function(participant) {
                        if(((theUbk == '6009') || (theUbk == 6008)) && $scope.participant && $scope.participant.theReason) {
                            var offsetdaysCount = offsetDays(m.getDate(),m.getMonth(),m.getFullYear());
                            if(offsetdaysCount > 60 && isLeap(m.getFullYear()) && offsetdaysCount <= 120){
                            	var subOrAdd = $scope.participant.theReason.retroDays > 0 ? 1 : 0
                                var beforeDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() - (parseInt($scope.participant.theReason.retroDays)- subOrAdd ));
                                var afterDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() + parseInt($scope.participant.theReason.futureDays));
                            }
                            else {
                                var beforeDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() - parseInt($scope.participant.theReason.retroDays));
                                var afterDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() + parseInt($scope.participant.theReason.futureDays));
                            }

                            $scope.arrCutOffDates.dtEffMin = beforeDate > participant.contractCovEffDte ? truncateToDay(beforeDate) : truncateToDay(participant.contractCovEffDte) ;
                            $scope.arrCutOffDates.dtEffMax = truncateToDay(afterDate);
                           //contractCovEffDte
                        }
                        var memberCurrent = employerUtility.getCurrentParticipant(participant.coveredIndivId, [$scope.employee.data.subscriber].concat($scope.employee.data.dependents || []));
						var cancelDate = employerUtility.getProviderCancellationDate(memberCurrent);
						employerUtility.normalizeReasonCodeDates($scope.reasonCodes, cancelDate);
						// we need to update participant.contractCovEffDte
						participant.contractCovEffDteForDisplay = participant.theReason.effDateForDisplay;
					}




					$scope.searchProviderDirectory = function(theParticipant) {
						var providerURLData = employerUtility.configureFindADoc('/employer/assist-employees/change-pcp', $scope, sessionData.strGroupName);
						var providerURL = providerURLData.url;
						if (providerURLData.newWindow) {
							window.open( providerURL, '_blank');
						} else {
							// we save this b c we have to find it when wht WPA Search Provider Directory returns to this page.
							storage.set('coveredIndivId', theParticipant.coveredIndivId);
							window.location.href = providerURL;
						}
					}
					var chgPcpFormIsValid = function() {
						var isValid = true;
						var theMsg = '';
						if (($scope.participant.pcpNbr == null) || ($scope.participant.pcpNbr == '')) {
							theMsg = 'Please enter a valid Provider Number.';
							isValid = false;
						}
						if (($scope.participant.theReason == null) || ($scope.participant.theReason.reasonCode == '') ) {
							theMsg += ' Please select a reason.';
							isValid = false;
						}
						var form = $scope["Providers_" + $scope.validationSuffix];
                        if (!form.$valid) {
                            theMsg += ' Please Enter a valid Date.';
                            isValid = false;
                        }
						if (!isValid) {
							$scope.feedback.showFeedback(theMsg, 'notification');
							$window.scrollTo(0, 0);
						}
						return isValid;
					}
					////////////////////////////////////////////////////////////////////
					// THIS SUBMITS THE NEW PCP IF THE VALIDATE-PCP SERVICE SUCCEEDED //
					$scope.$watch('validationResultsMessage', function(msgValue) {
							if ((typeof msgValue != 'undefined') && (msgValue != '')) {
								$window.scrollTo(0, 0);
								if (msgValue == 'success') {
									var ubk = sessionData.employerInfo.brandName;
									$scope.changePcpSuccessMsg = changePcpSuccess.getSuccessMessage(ubk, $scope.participant.theReason.reasonCode);
									var p = employerUtility.makePayloadForChangePcp($scope, sessionData);
									if (p == null) {
										$scope.validateAndSaveAreRunning = false;
										$scope.feedback.showFeedback('There was an error in the code. Sorry.', 'notification')
										return;
									}
									services.rbsmbl.svcChangePcp().postData(p).then(
										function(resp) {
											$scope.validateAndSaveAreRunning = false;
											if (resp.data && resp.data.payload && resp.data.payload.pcpInfo && resp.data.payload.pcpInfo[0]
													&& resp.data.payload.pcpInfo[0]) {
												// the first item in the array above is the OLD pcp, the second item is the NEW
												// However, the first item has the indicator as to success/fail

												// if resp.data.payload.pcpInfo[0].pcpDenyCde == '' the change was successful
												if (resp.data.payload.pcpInfo[0].pcpDenyCde == '') {
													if (($scope.changePcpSuccessMsg == '') || ((typeof $scope.changePcpSuccessMsg) == 'undefined')) {
														alert('Success message based on ubk is empty.')
														return;
													}
													// we need to update the pcp name in the form's <input> for that.
													var curParticipant =  employerUtility.getCurrentParticipant($scope.coveredIndivId, $scope.allParticipants);
													curParticipant.pcpName = $scope.newPcpInfo.pcpName;
													$scope.feedback.showFeedback('The PCP was successfully updated.', 'success');
													modal.open({
														template: require('modals/changePcpSuccess.html'),
														scope: $scope
													});
												} else {
													if (resp.data.payload.pcpInfo[0].msgArea) {
														var firstCap = (resp.data.payload.pcpInfo[0].msgArea).substring(0,1).toUpperCase();
														var theRest = (resp.data.payload.pcpInfo[0].msgArea).substring(1,99).toLowerCase();
														$scope.feedback.showFeedback(firstCap + theRest, 'notification');
													} else {
														$scope.feedback.showFeedback('There was an error on the server. Please try again later.', 'failure');
													}
												}
											} else {
												$scope.feedback.showFeedback('There was an error on the server. Please try again later.', 'failure');
											}
										},
										function(err) {
											$scope.validateAndSaveAreRunning = false;
											if (err.data && err.data.returnCodeDescription) {
												$scope.feedback.showFeedback(err.data.returnCodeDescription, 'notification')
											} else {
												$scope.feedback.showFeedback('The update was not successful.', 'notification');
											}
										}
									)
								} else {
									$scope.validateAndSaveAreRunning = false;
									$scope.feedback.showFeedback(msgValue, 'notification');
								}
							} } );

					$scope.validateAndSaveAreRunning = false;

					$scope.submitNewPcp = function(participant) {
						$scope.feedback.hideFeedback();
						if (!chgPcpFormIsValid()) {
							return;   // if there are required fields just show those boxes
						}
						$scope.validateAndSaveAreRunning = true;
						$scope.coveredIndivId = participant.coveredIndivId;
						validatePcpFactory.validatePcp($scope, participant);
						// that method puts a message on $scope.validationResultsMessage which we $watch above
					}

					////////////////////////////////////////////////////////////////////
					// Here we handle the results from Search Provider Directory
					var qsParams = $location.search();
					if (qsParams && qsParams.PCPNumber) {
						var coveredIndivId = storage.get('coveredIndivId');
						if (coveredIndivId.length > 0) {
						// we need to update ONLY the participant who clicked Search Provider Directory
							employerUtility.updateParticipantByCoveredIndivId(coveredIndivId, $scope.allParticipants, qsParams);
							storage.set('coveredIndivId', '');  // destroy it to avoid possible phi
						}
					} else {
						// TODO: looks like the next 2 lines do nothing. Test w o them.
						$scope.participant.pcpNbr = $scope.participant.pcpNbr;
						$scope.participant.pcpName = $scope.participant.pcpName;
					}
					$scope.theReason = '';
					$scope.checkAll = function() {
						for (var i = 0; i < $scope.arrPartis.length; i++) {
							$scope.arrPartis[i].selected = !$scope.arrPartis[i].selected;
						}
					}

					// Function for Copying Provider Information to the other cards/participants
					$scope.copyData = function (person) {
						// arrPartis should be an array of participants NOT including the one where Copy To Others was clicked
						for (var i = 0; i < $scope.arrPartis.length; i++) {
							if ($scope.arrPartis[i].selected == true) {
								$scope.arrPartis[i].pcpName = person.pcpName;
								$scope.arrPartis[i].pcpNbr = person.pcpNbr;
								$scope.arrPartis[i].contractCovEffDte = person.contractCovEffDte;
							}
							$scope.closeModal();
						}
					};
					// Copy to Other or Open Modal
					$scope.clickCopyToOthers = function (participant) {
						$scope.arrPartis = employerUtility.getParticipantsOtherThanThisOne(participant.guid, $scope.allParticipants)
						$scope.selectedPerson = participant;
							modal.open({
								template: require('pages/employee/modals/otherProviderModal.html'),
								scope: $scope
							});
					};
			}]
		};
	}]);
};
